import { Popover, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";

export function SwitchProduct(data: any) {
  const [show, setShown] = useState(false);
  const contextRef = React.useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  function getCurrentPlatformData(platform: string) {
    const currentPlatform = Array.isArray(data?.data)
      ? data.data.find(
          (obj: any) => obj.platform?.toLowerCase() === platform.toLowerCase()
        )
      : undefined;
    return currentPlatform?.data;
  }

  const products = [
    {
      label: "CAPTABLE",
      icon: "/media/switchProductIcons/captable.svg",
      redirectURL: process.env.REACT_APP_OPTIONS_URL,
      bgColor: "#E6EFFF",
      access:
        (getCurrentPlatformData("captable") &&
          getCurrentPlatformData("captable")?.access) ||
        false,
    },
    {
      label: "PORTFOLIO",
      icon: "/media/switchProductIcons/portfolio.svg",
      redirectURL: process.env.REACT_APP_INVESTOR_URL,
      bgColor: "#E9FBF3",
      access:
        (getCurrentPlatformData("investor") &&
          getCurrentPlatformData("investor")?.access) ||
        false,
    },
    {
      label: "TASK MANAGER",
      icon: "/media/switchProductIcons/task_manager.svg",
      className: "px-1",
      redirectURL: process.env.REACT_APP_TASKMANAGER_URL,
      bgColor: "#FEF2E7",
      access:
        (getCurrentPlatformData("taskmanager") &&
          getCurrentPlatformData("taskmanager")?.access) ||
        false,
    },
  ];

  const handleRedirect = (redirectURL: string) => {
    window.location.href = `${redirectURL}`;
  };

  return (
    <>
      <Popover className="relative">
        <Popover className="relative">
          <div>
            <Popover.Button
              onClick={() => setShown(!show)}
              onMouseEnter={() => {
                setShown(true);
              }}
              onMouseLeave={() => {
                setShown(false);
              }}
              className={`-ml-1.5 flex gap-2 cursor-pointer items-center ${
                pathname !== "/profile"
                  ? "bg-white text-secondary"
                  : "bg-secondary text-white"
              } `}
            >
              <div
                className={`group cursor-pointer  flex items-center justify-center p-2 rounded-full ${
                  show
                    ? " transition-transform duration-300 scale-105 text-primary bg-primary bg-opacity-10"
                    : ""
                } `}
              >
                {" "}
                <Icon
                  icon="icon-park-outline:application-menu"
                  className={`text-gray-600   ${show ? "text-primary" : ""}`}
                  height={20}
                />
              </div>
            </Popover.Button>
          </div>
          <Transition
            show={show}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel
              onMouseEnter={() => {
                setShown(true);
              }}
              onMouseLeave={() => {
                setShown(false);
              }}
              ref={contextRef}
              className="absolute z-10 mt-5 flex w-screen max-w-max -right-12"
            >
              <div className="w-screen max-w-xs flex-auto overflow-hidden rounded-lg bg-white text-sm leading-6 shadow-lg border-2 border-gray-200">
                <div className="grid grid-cols-2 gap-4 p-6">
                  {products.map((product, index) =>
                    product.access ? (
                      <div
                        key={index}
                        className={`border rounded-lg flex flex-col items-center justify-center p-4 hover:bg-[var(--hover-bg)] border-gray-100 gap-2 cursor-pointer ${product?.className}`}
                        onClick={() =>
                          handleRedirect(product?.redirectURL || "")
                        }
                        style={
                          {
                            "--hover-bg": product.bgColor,
                          } as React.CSSProperties
                        }
                      >
                        <img src={product.icon} />
                        <p>{product.label}</p>
                      </div>
                    ) : (
                      <></>
                    )
                  )}
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>
      </Popover>
    </>
  );
}
